<template>
    <div class="row threelogo-div">
        <div class="col-lg-4 col-md-4 ml-auto mr-auto">
            <img :src="partnerImg" class="img-partner" alt="partner">
            <h6 class="feature-title">Partner up or go solo</h6>
            <p class="feature-desc">PlusMinus is designed for however you live your life. We are the first group banking solution for everyone.</p>
        </div>
         <div class="col-lg-4 col-md-4 ml-auto mr-auto">
            <img :src="goalImg" class="img-goal" alt="goal">
            <h6 class="feature-title">Set goals and plans</h6>
            <p class="feature-desc">Money is personal, so PlusMinus is too. What are your goals? We’ll help you personlize your savings, spending and investing goals.</p>
        </div>
         <div class="col-lg-4 col-md-4 ml-auto mr-auto">
            <img :src="automatedImg" class="img-automated" alt="automated">
            <h6 class="feature-title">AUtomate and save</h6>
            <p class="feature-desc">PlusMinus will do the hard work for you. Fund your goals first, cover your costs, spend the rest guilt-free.</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'newsletterTwo',
        data (){
            return {
                partnerImg: require("../assets/img/features/partner--relationship_2_.png"),
                goalImg: require("../assets/img/features/agriculture_1_.png"),
                automatedImg: require("../assets/img/features/automate--modular--management_1_.png"),
            }
        }
    }
</script>

<style>
.threelogo-div{
    text-align: center;
    padding:5%;
}
.feature-title{
    padding-top:15%;
    color: #000000;
    font-family: Nunito Sans;
    font-style: normal;
    font-weight: 900;
}
.feature-desc{
    padding-top:5%;
    font-family: Nunito Sans;
    font-style: normal;
    font-weight: normal;
    color: #000000;
}
</style>